<template>
    <v-container grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Observaciones</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 lg8>
                <div id="editor"></div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EditorJS from '@editorjs/editorjs';
    import Header from '@editorjs/header';
    import List from '@editorjs/list';
    import Checklist from '@editorjs/checklist';
    import Image from '@editorjs/image';

    export default {
        name: "obs",
        data() {
            return {
                editor: {}
            }
        },
        mounted() {
            this.editor = new EditorJS({
                holder: 'editor',
                autofocus: true,
                placeholder: 'Ingrese las observaciones',
                tools: {
                    header: Header,
                    list: List,
                    checklist: Checklist,
                    image: {
                        class: Image,
                        config: {
                            endpoints: {
                                byFile: 'api/calidad/incidencia/obs/image-store', // Your backend file uploader endpoint
                                byUrl: 'api/calidad/incidencia/obs/fetchUrl', // Your endpoint that provides uploading by Url
                            },
                            additionalRequestData: {
                                incidencia_id: 1
                            },
                            additionalRequestHeaders: {
                                'X-CSRF-TOKEN': window.Laravel.csrfToken,
                                'X-Requested-With': 'XMLHttpRequest',
                                'Authorization': 'Bearer ' + this.$ls.get('token')
                            }
                        }
                    }
                },
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/calidad/no_conformidad/obs.vue